/**
 * Format a date as numeric DD-MM-YYYY with dashes (e.g. "06-08-2026").
 * Accepts an ISO date string ("2026-08-06" or full ISO) or a Date.
 * UTC-based so a YYYY-MM-DD string never shifts a day across timezones.
 * Returns '' for empty/invalid input.
 */
export function formatDMY(value: string | Date | null | undefined): string {
  if (!value) return '';
  const d =
    typeof value === 'string'
      ? new Date(value.length === 10 ? `${value}T00:00:00.000Z` : value)
      : value;
  if (Number.isNaN(d.getTime())) return '';
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = d.getUTCFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

/**
 * Format a real timestamp (e.g. an audit event time) as DD-MM-YYYY in the
 * viewer's LOCAL timezone, so an event at 02:00 IST shows today's date and not
 * the previous UTC day. Use formatDMY for date-only values stored at UTC midnight.
 */
export function formatLocalDMY(value: string | Date | null | undefined): string {
  if (!value) return '';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}-${mm}-${d.getFullYear()}`;
}

/** Today's LOCAL calendar date as YYYY-MM-DD (for <input type="date"> defaults). */
export function localTodayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Convert a YYYY-MM-DD date-input value to the ISO date-time (UTC midnight) the API stores. */
export function dateInputToIso(value: string): string {
  return `${value}T00:00:00.000Z`;
}
